/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 旗舰店精彩回顾
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ShopSwonderfulReviewParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: ShopSwonderfulReviewParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shops/wonderful/review`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
